import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'login/actions/loginActions.js';
import Garage from '@sm360/widget-commons-garage';
import { Quote } from '@sm360/widget-commons-vehicle';

const GarageContainer = (props) => {
    return <Garage.Garage {...props} deleteQuote={props.actions.deleteQuote} />;
};

GarageContainer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    timeSaved: PropTypes.number,
    isReservationMode: PropTypes.bool,
    tradeInTaxCredits: PropTypes.number.isRequired,
    actions: PropTypes.shape({
        deleteQuote: PropTypes.func.isRequired,
    }).isRequired,
    quotes: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteModel)),
};

GarageContainer.displayName = 'GarageContainer';

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        quotes: state.quotes,
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GarageContainer);



// WEBPACK FOOTER //
// ./src/components/Transaction/TransactionActionDetails/GarageContainer.jsx